<template>
  <div class="dummy-auth-view">
    <div class="container">
      <h1 class="title">Easy design in tool</h1>

      <div class="row col-lg-6" v-if="!dummyAuthLoggedIn">
        <div class="login-form-header-text">
          <p>
            The Easy Design-In Tool (EDIT) helps you find your optimal LED
            solutions quickly and automatically calculates the consequences of
            your choices.
          </p>
        </div>
        <form @submit.prevent="submit" class="login-form">
          <div class="row">
            <div class="col">
              <label for="inputEmail">Email</label>
              <input
                type="text"
                class="form-control"
                id="inputEmail"
                name="inputEmail"
                v-model="username"
              />
            </div>
            <div class="col">
              <label for="inputPassword">Password</label>
              <input
                type="password"
                class="form-control"
                id="inputPassword"
                name="inputPassword"
                v-model="password"
              />
              <div class="row-below-input">
                <a href="">Forgot password</a>
              </div>
            </div>
          </div>
          <div class="bottom-buttons">
            <input
              type="submit"
              class="btn btn-block btn-secondary"
              value="Login"
            />
            <input
              type="button"
              class="btn btn-block btn-outline-secondary"
              value="Or create an account"
            />
          </div>
        </form>
      </div>

      <div class="row" v-if="dummyAuthLoggedIn && !loading">
        <form @submit.prevent="takeRole" class="impersonate-form">
          <div class="form-group">
            <label>Select role *</label>
            <div
              class="custom-control custom-checkbox"
              v-for="role in roles"
              :key="role.id"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                :id="role.id"
                @change="toggleRole(role)"
              />
              <label class="custom-control-label" :for="role.id">{{
                role.name
              }}</label>
            </div>
          </div>

          <div class="form-group row">
            <label for="roles" class="col-lg-2 auth-form-input-label"
              >Select company *</label
            >
            <select
              class="form-control col-lg-4 col-sm-6"
              name="companies"
              v-model="company"
              id="companies"
            >
              <option value="" disabled selected>Select company</option>
              <option
                :value="company"
                v-for="company in companies"
                :key="company.id"
              >
                {{ company.name }}
              </option>
            </select>
          </div>

          <div
            class="form-group row"
            v-for="prop in Object.keys(impersonationData)"
            :key="prop"
          >
            <label for="prop" class="col-lg-2 auth-form-input-label">{{
              prop
            }}</label>
            <input
              type="text"
              class="form-control col-lg-4 col-sm-6"
              v-model="impersonationData[prop]"
            />
          </div>

          <input
            type="submit"
            class="btn btn-secondary"
            value="Submit"
            :disabled="!requiredImpersonateFieldsFilled"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { http } from "@/services/http";

export default {
  name: "DummyAuthLogin",
  data() {
    return {
      username: null,
      password: null,
      chosenRoles: [], // required
      company: null, // required
      loading: false,
      companies: [],
      roles: [],
      impersonationData: {
        anonymousCompanyId: "",
        anonymousUserId: "",
        firstname: "",
        lastname: "",
        email: "",
        kamEmail: "",
      },
    };
  },
  computed: {
    ...mapState("brain/auth", ["dummyAuthLoggedIn"]),

    requiredImpersonateFieldsFilled() {
      return this.company !== null;
    },
  },
  methods: {
    submit() {
      this.$store
        .dispatch("brain/auth/dummyAuthLogin", {
          username: this.username,
          password: this.password,
        })
        .then(() => {
          this.$snotify.success("Dummy login successful");
          Promise.all([
            http.get(`api/v2/auth/dummy/companies`).then((response) => {
              this.companies = response.data.data.sort((a, b) =>
                a.name.localeCompare(b.name)
              );
            }),

            http.get(`api/v2/auth/dummy/roles`).then((response) => {
              this.roles = response.data.data;
            }),
          ]);
          this.loading = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$snotify.error("Email or password incorrect.");
          } else {
            this.$snotify.error(err);
          }
        });
    },
    takeRole() {
      this.$store
        .dispatch("brain/auth/takeRole", {
          anonymousCompanyId: this.impersonationData.anonymousCompanyId,
          anonymousUserId: this.impersonationData.anonymousUserId,
          companyId: this.company ? this.company.id : 0,
          email: this.impersonationData.email,
          firstname: this.impersonationData.firstname,
          kamEmail: this.impersonationData.kamEmail,
          lastname: this.impersonationData.lastname,
          roles: this.chosenRoles.map((role) => role.name),
        })
        .then((response) => {
          this.$router.push({ name: "landing" });
          this.$snotify.success(
            `Now logged in as: ${response.data.data.companyName}`
          );
        })
        .catch((err) => {
          this.$snotify.error(err);
        });
    },
    toggleRole(role) {
      if (this.chosenRoles.includes(role)) {
        this.chosenRoles = this.chosenRoles.filter(
          (chosenRole) => chosenRole.id !== role.id
        );
      } else {
        this.chosenRoles.push(role);
      }
    },
  },
  mounted() {
    if (this.dummyAuthLoggedIn) {
      Promise.all([
        http.get(`api/v2/auth/dummy/companies`).then((response) => {
          this.companies = response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        }),

        http.get(`api/v2/auth/dummy/roles`).then((response) => {
          this.roles = response.data.data;
        }),
      ]);
    }
  },
};
</script>

<style lang="scss">
.dummy-auth-view {
  flex-grow: 2;

  .title {
    margin-top: 30px;
  }

  form {
    width: 100%;
  }
}

.impersonate-form {
  width: 100%;
  margin-bottom: 20px;
}

.auth-form-input-label {
  text-align: right;
  margin-top: 0;
  margin-bottom: 0;
  align-self: center;
}

.login-form-header-text {
  p {
    margin-bottom: 40px;
    margin-top: 20px;
  }
}

.bottom-buttons {
  margin-top: 30px;
}

.row-below-input {
  margin-top: 10px;
  a {
    position: absolute;
  }
}
</style>
